import { compose, hoistStatics, lifecycle, withHandlers, withState, defaultProps, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Feedback from './Feedback';
import WithLoading from '../../../components/WithLoading';
import FeedbackService from '../../../services/feedback.service';
import ModuleService from '../../../services/module.service';
import { settingsActions } from '../../../reducers/settings';


const goToPage = props => async (nextPage) => {
  const { criteria, setCriteria, setFeedback, setCount } = props;
  const page = nextPage > -1 ? nextPage : 0;
  const { data, count } = await FeedbackService.getData({ ...criteria, page });
  setFeedback(data);
  setCount(count);
  setCriteria({ ...criteria, page });
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

const callbackToSetSearch = props => async (value) => {
  await goToPage({ ...props, criteria: { ...props.criteria, search: value } })(0);
};

const defaultCriteria = {
  page: 0,
  limit: 5,
  sortBy: 'created_at',
  order: 'desc',
  status: [
    FeedbackService.STATUS_IDEA,
    FeedbackService.STATUS_IN_PROGRESS,
    FeedbackService.STATUS_PLANNED
  ],
};

const changeFilter = props => async (e, value) => {
  e.preventDefault();
  const { setFilters, filters, criteria, setFiltersCount } = props;
  const newFilters = { ...filters, [value]: !filters[value] };
  const statusArr = Object.keys(newFilters).filter(key => newFilters[key]);
  setFilters(newFilters);
  setFiltersCount(statusArr.length);
  goToPage({ ...props, criteria: { ...criteria, status: statusArr } })(0);
};

const defaultFilters = (props) => {
  const filterObj = FeedbackService.getStatusList(props.t);
  Object.keys(filterObj).forEach((item) => {
    if (Number(item) === FeedbackService.STATUS_DONE) filterObj[item] = false;
    else filterObj[item] = true;
  });
  return filterObj;
};

const toggleFilters = props => (e) => {
  e.preventDefault();
  const { showFilters, setShowFilters } = props;
  setShowFilters(!showFilters);
};

const mapStateToProps = state => ({
  modulesSettings: state.modules.modulesSettings,
});

const mapDispatchToProps = {
  updateSettings: settingsActions.updateSettings,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  withState('count', 'setCount', 0),
  withState('feedback', 'setFeedback', []),
  withState('criteria', 'setCriteria', defaultCriteria),
  withState('isLoading', 'setIsLoading', true),
  withState('showFilters', 'setShowFilters', false),
  withState('filters', 'setFilters', props => defaultFilters(props)),
  withState('filtersCount', 'setFiltersCount', props =>
    (Object.keys(props.filters).filter(key => props.filters[key])).length),
  lifecycle({
    async componentDidMount() {
      const { setIsLoading, setCount, criteria, setFeedback, updateSettings } = this.props;
      updateSettings({ hasLoadedPage: false });
      const { data, count } = await FeedbackService.getData(criteria);
      await setFeedback(data);
      await setCount(count);
      setIsLoading(false);
      updateSettings({ hasLoadedPage: true });
    },
  }),
  withProps(props => ({
    moduleTitle: props.modulesSettings[ModuleService.TYPE_FEEDBACK].title || props.t('Feedback'),
    backgroundColor: props.modulesSettings[ModuleService.TYPE_FEEDBACK].color ?
      props.modulesSettings[ModuleService.TYPE_FEEDBACK].color : props.modulesSettings[ModuleService.TYPE_FEEDBACK].default_color,
    backgroundCover: props.modulesSettings[ModuleService.TYPE_FEEDBACK].cover,
    enableCoverColor: props.modulesSettings[ModuleService.TYPE_FEEDBACK].enable_cover_color,
  })),
  defaultProps({
    statusList: FeedbackService.getStatusList,
  }),
  withHandlers({
    goToPage,
    changeFilter,
    toggleFilters,
    callbackToSetSearch,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Feedback)));



// WEBPACK FOOTER //
// ./src/views/modules/feedback/index.js